import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    useRecordContext,
    required,
} from 'react-admin';
import { EditToolbar } from "../../common/EditToolbar";
import { ActivationCodes } from '../../custom';

const ActivationCodesEdit = () => {
    return (
        <Edit resource="activation-codes" title={<ActivationTitle />}>
            <SimpleForm toolbar={<EditToolbar />}>
                <TextInput source="title" validate={[required()]} fullWidth />
                <TextInput source="secret" validate={[required()]} fullWidth />
            </SimpleForm>
        </Edit>
    );
};

const ActivationTitle = () => {
    const record = useRecordContext<ActivationCodes>();
    return record ? <span>{record.code}</span> : null;
};

export default ActivationCodesEdit;
